module.exports = {"development":{"ESF_API":"https://services-uat.msem.tech/api/esf","CM_ROOT":"https://club-med-uat.esf-plus.com"},"testing":{"ESF_API":"https://services-uat.msem.tech/api/esf","CM_ROOT":"https://club-med.uat.esf-plus.com"},"integration":{"ESF_API":"https://services-integration.msem.tech/api/esf","CM_ROOT":"https://club-med-integration.esf-plus.com"},"uat":{"ESF_API":"https://services-uat.msem.tech/api/esf","CM_ROOT":"https://club-med-uat.esf-plus.com"},"production":{"ESF_API":"https://services.msem.tech/api/esf","CM_ROOT":"https://club-med.esf-plus.com"}}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 56
// module chunks = 0